import React, { useState, useEffect } from "react";
import Card from "components/card/Card.js";
import DownTimeListTable from "components/table/downTimeListTable";
import useGetRoles from "hooks/roles/useGetRoles";
import LoadingForm from "components/loader/LoadingForm";
import noGroupImage from "assets/img/layout/noGroup.png";
import {
  Box,
  Button,
  Tooltip,
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import AddRoleForm from "./addRoleForm";
import EditRoleForm from "./editRoleForm";
import useDeleteRole from "hooks/roles/useDeleteRole";
import DeleteModal from "components/modal/deleteModal";
import useGetGroupWisePermission from "hooks/groupPermissions/useGetGroupWisePermission";
import { getDashboardPermissions } from "Permissions";

const Role = () => {
  const [editData, setEditData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const {
    isLoading,
    error,
    data: roleData,
    refetch,
    isFetching,
  } = useGetRoles(20, currentPage);

  const {
    isLoading: isPerLoading,
    error: perError,
    data: permissionsData,
  } = useGetGroupWisePermission();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [deleteId, setDeleteId] = useState(null);

  const { mutate: deleteRole } = useDeleteRole(onClose);

  useEffect(() => {
    refetch();
  }, [currentPage]);

  if (isLoading || isFetching) return <LoadingForm />;
  //if (error) return null;

  const handleDelete = (id) => {
    setDeleteId(id);
    onOpen();
  };
  const handleEdit = (row) => {
    setEditData(row);
    setShowEditForm(true);
  };

  const columnsData = [
    {
      Header: "ID",
      accessor: (row) => {
        return (
          <Text
            color={"ndmsColors.purple.200"}
            fontSize="12px"
            fontWeight="700"
          >
            {row.id}
          </Text>
        );
      },
    },
    {
      Header: "ROLE",
      accessor: (row) => {
        return (
          <Text color={"ndmsColors.blue.100"} fontSize="12px" fontWeight="700">
            {row.role_type}
          </Text>
        );
      },
    },
    {
      Header: "SLUG",
      accessor: (row) => {
        return (
          <Text color={"ndmsColors.blue.100"} fontSize="12px" fontWeight="700">
            {row.slug}
          </Text>
        );
      },
    },
    {
      Header: "   ",
      accessor: "   ",
    },
    {
      Header: "   ",
      accessor: "------",
    },
    {
      Header: "   ",
      accessor: "=======",
    },
    {
      Header: "   ",
      accessor: "++++++++++",
    },
    {
      Header: "ACTION",
      accessor: (row) => {
        return (
          <Flex justifyContent="center" align="center">
            {getDashboardPermissions("role.update") ? (
              <Tooltip hasArrow label="Edit" bg="#2B3674">
                <Flex mr="10px" onClick={() => handleEdit(row)}>
                  <Icon
                    as={EditIcon}
                    width="17px"
                    height="17px"
                    color="ndmsColors.purple.200"
                  />{" "}
                </Flex>
              </Tooltip>
            ) : null}
            {getDashboardPermissions("role.delete") ? (
              <Tooltip hasArrow label="Delete" bg="ndmsColors.red.200">
                <Flex onClick={() => handleDelete(row.id)}>
                  <Icon
                    as={DeleteIcon}
                    width="17px"
                    height="17px"
                    color="ndmsColors.red.200"
                  />{" "}
                </Flex>
              </Tooltip>
            ) : null}
          </Flex>
        );
      },
    },
  ];

  return (
    <>
      {showAddForm && (
        <AddRoleForm
          setShowAddForm={setShowAddForm}
          permissionsData={permissionsData?.data}
        />
      )}
      {showEditForm && (
        <EditRoleForm
          setShowEditForm={setShowEditForm}
          editData={editData}
          permissionsData={permissionsData?.data}
        />
      )}
      {!showAddForm && !showEditForm && (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
          <Flex align="center" justifyContent="flex-end">
            <Button
              bg="ndmsColors.purple.200"
              minWidth="104px"
              borderRadius="6px"
              mb="42px"
              _hover={{ bg: "ndmsColors.blue.400" }}
              _active={{ bg: "ndmsColors.blue.400" }}
              onClick={() => setShowAddForm(true)}
            >
              <Icon as={AddIcon} w={3} h={3} color="#FFF" />
              <Text ml="10px" color="#FFF" fontSize="14px">
                {" "}
                Add
              </Text>
            </Button>
          </Flex>

          <Card
            direction="column"
            w="100%"
            px="0px"
            overflowX={{ sm: "scroll", lg: "hidden" }}
          >
            {roleData?.data[0]?.result?.length > 0 ? (
              <Flex direction="column" p="20px">
                <DownTimeListTable
                  tableData={roleData?.data[0]?.result}
                  columnsData={columnsData}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPage={roleData?.data[0]?.total_pages}
                />
              </Flex>
            ) : (
              <Flex
                align="center"
                justify="center"
                mt="200px"
                cursor="pointer"
                mb="150px"
                onClick={() => setShowAddForm(true)}
              >
                <Flex direction="column" justify="center" align="center">
                  <Image src={noGroupImage} width="70px" alt="no-group" />
                  <Text fontSize={"22px"} color="#2B3674" fontWeight="bold">
                    You Don’t Have Any Roles added
                  </Text>
                </Flex>
              </Flex>
            )}
          </Card>
        </Box>
      )}
      <DeleteModal
        onOpen={onOpen}
        onClose={onClose}
        isOpen={isOpen}
        id={deleteId}
        deleteItem={deleteRole}
      />
    </>
  );
};

export default Role;
